import React from "react"
import AuthorBlock from "./AuthorBlock"

function BlogByAuthor({ data, pageContext }) {
  const { previousPagePath } = pageContext
  const author = data.ghostAuthor

  return (
    <>
      {!previousPagePath && (
        <div className="max-w-sm mx-auto md:max-w-none">
          <AuthorBlock {...{ data }} />
          <div
            className="pb-4 mt-5 mb-10 border-b border-gray-700"
            data-aos="fade-up"
          />
        </div>
      )}

      {previousPagePath && (
        <div
          className="max-w-3xl mx-auto text-center pb-12 md:pb-16"
          data-aos-id-blog
        >
          <h1
            className="h2 mb-4 capitalize"
            data-aos="fade-up"
            data-aos-anchor="[data-aos-id-blog]"
          >
            {author.name}
          </h1>
        </div>
      )}
    </>
  )
}

export default BlogByAuthor
